import styled from 'styled-components';

export const BoxContainer = styled.div`
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
`;
